import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CartOverlayService {
  private _openCart$ = new BehaviorSubject(false);

  get cartIsOpen$() {
    return this._openCart$.asObservable();
  }

  openCart() {
    this._openCart$.next(true);
  }

  closeCart() {
    this._openCart$.next(false);
  }

  hasActiveOverlays(): boolean {
    const selectors = [
      'mat-bottom-sheet-container',
      'mat-dialog-container'
    ];
    return selectors.some(selector => 
      document.querySelector(selector) !== null
    );
  }
}
